<template>
  <section style="margin-top: 10px !important;">
    <div class="d-flex w-100 text-right">
      <ul class="more-detail">
        <li
          v-if="hasExtraDescription"
          @click="changeTab('content')"
          :class="'product-content ' + contentTab"
        >
          توضیحات
        </li>
        <li
          @click="changeTab('properties')"
          :class="'product-property ' + propertiesTab"
        >
          ویژگی‌های کالا
        </li>
        <li
          @click="changeTab('attribute')"
          :class="'technical-property ' + attributeTab"
        >
          مشخصات
        </li>
        <li @click="changeTab('comment')" :class="'comment ' + commentTab">
          دیدگاه‌ها
        </li>
      </ul>
    </div>
    <hr id="line" />
    <div v-if="tab === 'properties'" class="properties-container">
      <ul>
        <li class="d-flex">
          <label>کد اصلی:</label>
          <p style="white-space: break-spaces;">
            &nbsp;{{ publish.main_code }}
          </p>
        </li>
        <li>
          <label>موضوع:</label>
          <router-link
            :to="
              '/category/' + (category && category.slug ? category.slug : '')
            "
          >
            {{ category && category.name ? category.name : "" }}
          </router-link>
        </li>
        <li>
          <label>وزن:</label>
          {{ product.weight }}
        </li>
        <li>
          <label>صفحه:</label>
          {{ product.page_count }}
        </li>
        <!-- <li>
          <label>تیراژ :</label>
          {{ product.circulation }}
        </li> -->
        <!-- <li>
          <label>نوع کتاب :</label>
          {{ product.book_type }}
        </li> -->
        <!-- <li>
        <label>نویسنده:</label>
        {{ product.author }}
        </li> -->
      </ul>
    </div>
    <div v-if="tab === 'content'" class="content">
      <div class="content-html" v-html="product.extra_description"></div>
    </div>
    <div v-if="tab === 'attribute'">
      <div
        v-for="(attribute, index) in product.attributes"
        :key="attribute[index]"
        class="attribute-container"
      >
        <div class="attribute-key">
          {{ attribute.key }}
        </div>
        <div class="attribute-value">
          {{ attribute.value }}
        </div>
      </div>
      <br />
      <div v-for="(attr, index) in product.dynamicAttributes" :key="index">
        <div v-if="attr.quantity > 0" class="publish-type">
          <hr v-if="index > 1" />
          <span>نوبت چاپ: {{ attr.publish }}</span>
        </div>
        <ul v-if="attr.quantity > 0" class="properties-container">
          <li>
            <label>نوع جلد:</label>
            {{ attr.cover_type }}
          </li>
          <li>
            <label>قطع:</label>
            {{ attr.book_size }}
          </li>
          <li>
            <label>سال چاپ:</label>
            {{ attr.publish_year }}
          </li>
          <li>
            <label>شابک:</label>
            {{ attr.isbn }}
          </li>
          <li>
            <label>تاریخ ورود:</label>
            {{ attr.created_at | moment("jYYYY-jMM-jDD") }}
          </li>
        </ul>
      </div>
    </div>
    <div v-if="tab === 'comment'" class="comments">
      <Comment :comments="product.comments" :productId="product.id"></Comment>
    </div>
  </section>
</template>
<script>
import Comment from "@/components/comment.component.vue";

export default {
  name: "ProductContent",
  props: ["product", "publish", "category"],
  components: { Comment },
  data() {
    return {
      tab: "properties",
      propertiesTab: "show",
      contentTab: "hide",
      attributeTab: "hide",
      commentTab: "hide",
      audioTab: "hide"
    };
  },
  watch: {
    product: {
      handler() {
        this.setDefaultTab();
      },
      immediate: true
    }
  },
  computed: {
    hasExtraDescription() {
      if (!this.product || this.product.extra_description === null) return false;
      const content = String(this.product.extra_description || "").trim();
      return content.length > 0;
    },
    parsedAudio() {
      try {
        if (!this.product || !this.product.audio) return [];
        const raw = this.product.audio;
        console.log('[ProductContent] raw product.audio:', raw);
        let arr;
        if (Array.isArray(raw)) {
          arr = raw;
        } else {
          try {
            arr = JSON.parse(raw);
          } catch (e) {
            // Attempt a lightweight repair if JSON seems truncated
            if (typeof raw === 'string') {
              let s = raw.trim();
              // Ensure it starts with [
              if (!s.startsWith('[')) s = '[' + s;
              // Cut to last complete object '}' and ensure closing ]
              const lastBrace = s.lastIndexOf('}');
              if (lastBrace !== -1) {
                s = s.substring(0, lastBrace + 1);
                // Ensure items separated correctly (strip dangling commas/backslashes)
                s = s.replace(/\\$/,'');
                s = '[' + s.replace(/^\[/,'');
                if (!s.endsWith(']')) s = s + ']';
                try {
                  console.warn('[ProductContent] Attempting to repair product.audio JSON before parse');
                  arr = JSON.parse(s);
                } catch (e2) {
                  console.error('[ProductContent] Repair parse failed', e2, s);
                  // Fallback: extract download_link values via regex from raw string
                  try {
                    const matches = (raw.match(/"download_link"\s*:\s*"([^"]+\.mp3)"/g) || []).map(m => m.replace(/.*:\s*"/,'').replace(/"$/,''));
                    console.warn('[ProductContent] Using regex fallback for audio links', matches);
                    const base = 'https://server.cheshmehdis.com/storage/';
                    arr = matches.map(link => ({ download_link: link, original_name: '', url: /^https?:\/\//i.test(link) ? link : (base + link.replace(/^\/*/, '')) }));
                  } catch (e3) {
                    console.error('[ProductContent] Regex fallback failed', e3);
                    return [];
                  }
                }
              } else {
                console.error('[ProductContent] No closing object brace found in audio string');
                // Regex fallback even if there is no closing brace at all
                try {
                  const matches = (raw.match(/"download_link"\s*:\s*"([^"]+\.mp3)"/g) || []).map(m => m.replace(/.*:\s*"/,'').replace(/"$/,''));
                  console.warn('[ProductContent] Using regex fallback for audio links (no closing brace)', matches);
                  const base = 'https://server.cheshmehdis.com/storage/';
                  arr = matches.map(link => {
                    const normalized = link.replace(/\\\//g, '/').replace(/\\/g, '');
                    const path = normalized.replace(/^\/*/, '');
                    const url = /^https?:\/\//i.test(normalized) ? normalized : (base + path);
                    return { download_link: normalized, original_name: '', url };
                  });
                } catch (e4) {
                  console.error('[ProductContent] Regex fallback failed (no closing brace)', e4);
                  return [];
                }
              }
            } else {
              return [];
            }
          }
        }
        if (!Array.isArray(arr)) return [];
        // Build storage base from intro_image if possible
        let storageBase = "";
        // Prefer explicit server base for audio files (inside storage)
        const explicitBase = 'https://server.cheshmehdis.com/storage/';
        if (!explicitBase) {
          if (this.product.intro_image && this.product.intro_image.includes('/storage/')) {
            storageBase = this.product.intro_image.split('/storage/')[0] + '/storage/';
          }
        }
        return arr
          .filter(it => it && (it.download_link || it.url))
          .map(it => {
            const dl = it.download_link || it.url || "";
            const normalized = dl.replace(/\\\//g, '/').replace(/\\/g, '');
            const hasProtocol = /^https?:\/\//i.test(normalized);
            const path = normalized.replace(/^\/*/, "");
            const url = hasProtocol
              ? normalized
              : (explicitBase ? explicitBase : (storageBase ? storageBase : "")) + path;
            return {
              original_name: it.original_name || "",
              url
            };
          });
      } catch (e) {
        console.error('[ProductContent] Failed to parse product.audio', e, this.product && this.product.audio);
        return [];
      }
    }
  },
  methods: {
    setDefaultTab() {
      this.changeTab(this.hasExtraDescription ? "content" : "properties");
    },
    changeTab: function(tab) {
      this.tab = tab;
      if (tab === "properties") {
        this.propertiesTab = "show";
        this.contentTab = "hide";
        this.attributeTab = "hide";
        this.commentTab = "hide";
        this.audioTab = "hide";
      }
      if (tab === "content") {
        this.contentTab = "show";
        this.attributeTab = "hide";
        this.commentTab = "hide";
        this.audioTab = "hide";
        this.propertiesTab = "hide";
      }
      if (tab === "attribute") {
        this.contentTab = "hide";
        this.attributeTab = "show";
        this.commentTab = "hide";
        this.audioTab = "hide";
        this.propertiesTab = "hide";
      }
      if (tab === "comment") {
        this.contentTab = "hide";
        this.attributeTab = "hide";
        this.commentTab = "show";
        this.propertiesTab = "hide";
        this.audioTab = "hide";
      }
      if (tab === "audio") {
        this.contentTab = "hide";
        this.attributeTab = "hide";
        this.commentTab = "hide";
        this.propertiesTab = "hide";
        this.audioTab = "show";
        this.$nextTick(() => {
          console.log('[ProductContent] Switched to audio tab. parsedAudio:', this.parsedAudio);
        });
      }
    }
  }
};
</script>
<style scoped>
.more-detail {
  list-style: none;
  display: flex;
  margin-bottom: 0;
  flex-wrap: wrap;
}

.more-detail li {
  border: 1px solid #e7e7e7;
  padding: 0.5rem 1rem;
  cursor: pointer;
  text-align: center;
}

#line {
  margin: 0 !important;
}

.more-detail li.show {
  background-color: #ffffff;
}

.more-detail li.hide {
  border: 1px solid #e7e7e7;
  background-color: #e7e7e7;
}

.attribute-container {
  display: flex;
  height: 40px;
  margin: 0.5rem auto;
}

.attribute-key,
.attribute-value {
  padding: 0.5rem 3rem;
}

.attribute-key {
  background-color: #e7e7e7;
  width: 300px;
  text-align: right;
}

.attribute-value {
  width: 100%;
  text-align: right;
  background-color: #fafafa;
}

.properties-container ul {
  list-style: none;
}
.properties-container {
  list-style: none;
  text-align: right;
  margin: 1rem;
  background-color: #e7e7e7;
  padding: 1rem;
  border-radius: 5px;
}

.properties-container li {
  margin-bottom: 0.5rem;
}

.properties-container li label::before {
  content: "\f111";
  font-family: FontAwesome;
  font-size: 12px;
  margin-left: 0.5rem;
}
.publish-type {
  position: relative;
}
.publish-type span {
  background-color: #fff;
  padding: 0.5rem;
  height: 40px;
  width: 120px;
  position: absolute;
  top: -20px;
  border-radius: 5px;
  left: calc(50% - 60px);
  text-align: center;
  border: 1px solid #000;
}
.content {
  padding: 1rem;
  line-height: 2;
  direction: rtl;
  text-align: justify;
}

.content .content-html {
  direction: rtl;
  text-align: justify;
}

.content .content-html :deep(p),
.content .content-html :deep(div),
.content .content-html :deep(span),
.content .content-html :deep(li),
.content .content-html :deep(h1),
.content .content-html :deep(h2),
.content .content-html :deep(h3),
.content .content-html :deep(h4),
.content .content-html :deep(h5),
.content .content-html :deep(h6) {
  direction: rtl;
  text-align: justify;
}

.content img {
  max-width: 100%;
}

@media screen and (max-width: 550px) {
  .more-detail li {
    margin: 0.25rem;
  }
}
</style>
